import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, map, of, tap } from 'rxjs';
import { Government } from '../interfaces/government';

@Injectable({
  providedIn: 'root'
})
export class TableService {
  governmentData: { [key: string]: Government; } = {};
  constructor (private http: HttpClient) { };

  processTableData = function (data: any | { tableData: string; }) {
    let actualTable: {}[];
    if (Array.isArray(data)) {
      actualTable = data;
    }
    else {
      actualTable = JSON.parse(data.tableData);
    }
    return actualTable;
  };

  processTable (campaignId: string, tableType: string, data: any[] | { tableData: any[]; }) {
    let realData = this.processTableData(data);
    localStorage.setItem(tableType + campaignId, JSON.stringify(realData));
  };

  getBaseTableType (tableType: string): Observable<{ [key: string]: string; }[]> {
    return this.http.get<{ [key: string]: any; }[]>('/api/table/' + tableType + '/cid/0');
  };

  loadTableDataForType (tableType: string, campaignId: string): Observable<{ [key: string]: string; }[]> {
    return this.http.get<{ [key: string]: string; }[]>('/api/table/' + tableType + '/cid/' + campaignId).pipe(
      tap(data => this.processTable(campaignId, tableType, data)),
      map(data => data)
    );
  };

  getTableDataForType (tableType: string, campaignId: string): Observable<{ [key: string]: string; }[]> {
    let tableData = localStorage.getItem(tableType + campaignId);
    if (tableData != null) {
      return of<{ [key: string]: string; }[]>(JSON.parse(tableData) as unknown as { [key: string]: string; }[]);
    }
    return this.loadTableDataForType(tableType, campaignId);
  };

  // passed in table.data is a WritableSignal!
  saveTableData (table: any, changedData: any[], campaignId: string) {
    return this.http.put<any[]>('/api/table/' + table.tableType + '/cid/' + campaignId, changedData).pipe(
      map(data => {
        this.processTable(campaignId, table.tableType, data);
        return data;
      })
    );
  };

  clearTableDataCacheForType (tableType: string, campaignId: string): void {
    localStorage.removeItem(tableType + campaignId);
  };

  deleteTableDataForType (tableType: string, campaignId: string): Observable<{ [key: string]: string; }[]> {
    this.clearTableDataCacheForType(tableType, campaignId);
    return this.http.delete<{ [key: string]: string; }[]>('/api/table/' + tableType + '/cid/' + campaignId);
  };

  getGovernments (): Government[] {
    return Object.values(this.governmentData);
  };

  setGovernment (government: Government) {
    this.governmentData[government.governmentId] = government;
  };

  getGovernment (id: number) {
    return this.governmentData[id];
  };

  getGovernmentById (governmentId: number, campaignId: string): Observable<Government> {
    let government = this.getGovernment(governmentId);
    if (government) {
      return of<Government>(government);
    }
    return this.getTableDataForType('governments', campaignId).pipe(
      map(response => {
        let governments: Government[] = response as unknown as Government[];
        for (const gov of governments) {
          this.setGovernment(gov);
        }
        return this.getGovernment(governmentId);
      }),
    );
  };
}
